<template>
  <div class="container">
    <loading v-model:active="loading" />
    <transition name="modal fade">
      <div class="modal-mask modal-backdrop">
        <div class="animate__fadeInDown animate__animated">
          <div class="modal-wrapper">
            <div class="modal-dialogs" role="document">
              <div class="modal-content modal-xs">
                <a
                  href="JavaScript:void(0)"
                  class="btn-cross text-right close-modal"
                  @click="hideModal($event)"
                  >&times;</a
                >

                <div class="modal-body mdScroll px-5 pb-4">
                  <div class="card-info-wrapper">
                    <div class="row align-items-center">
                      <div class="col-md-6">
                        <div class="img-card wood-card-frame refil-nft">
                          <VideoBlock :link="items.value.templ_id" />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div
                          class="card-info-content wood-card-frame py-lg-4 py-2"
                        >
                        <br>
                          <h6 class="text-glow name">{{ items.value.name }}</h6>
                          <h6 class="text-white">{{ items.value.schema }}</h6>
                          <h6 class="text-white">
                            Energy {{ items.value.energy }}
                          </h6>
                          <h6 class="text-white">
                            Level {{ items.value.level }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h4 class="tm5 modal-title d-inline-block">Refill Energy</h4>
                  <div class="energy-wrapper" v-if="foods.length">
                    <template v-for="(food, index) in foods" :key="index">
                      <div class="energy-content" v-if="food.value > 0">
                        <p class="text-success">({{ food.value }})</p>
                        <div
                          class="img-frame"
                          @click="selectFood(food.key.split(',')[1], index)"
                          :class="selectedFood[index] ? 'selected-card' : ''"
                        >
                          <img
                            :src="`/images/energyimg/${
                              food.key.split(',')[1]
                            }.png`"
                            alt=""
                          />
                        </div>
                        <p>{{ getHealth(food.key.split(",")[1]) }}%</p>
                      </div>
                    </template>
                  </div>
                  <div class="energy-wrapper" v-else>
                    <p>
                      You need foods to refill, <a href="/market">Shop here</a>
                    </p>
                  </div>
                  <div class="text-center w-100 attack_btn mt-5">
                    <button @click="fillEnergy()">Refill</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
  <script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VideoBlock from "@/components/VideoBlock.vue";
import { mapGetters } from "vuex";
import ApiService from "@/services";
export default {
  name: "RefillEnergyModal",
  components: {
    Loading,
    VideoBlock
  },
  computed: {
    ...mapGetters(["foods"]),
  },
  props: ["error", "showModel", "items"],
  showModal: true,
  data() {
    return {
      amount: null,
      token: false,
      loading: false,
      symbol: "WWS",
      walletBalance: null,
      selectedFood: [],
      selectedEnergy: "",
    };
  },
  methods: {
    getHealth(schema) {
      return ApiService.getHealthVal(schema);
    },
    selectFood(energy, index) {
      this.selectedFood = [];
      this.selectedFood[index] = true;
      this.selectedEnergy = this.getHealth(energy);
    },
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
    },
    async fillEnergy() {
      if (!this.selectedEnergy) {
        ApiService.errorMsg("Select food");
        return;
      }
      const data = {
        contract: process.env.VUE_APP_CONTRACT,
        action: "fillenergy",
        data: {
          owner: localStorage.getItem("wax_user"),
          asset_id: this.items.key,
          energy: this.selectedEnergy,
        },
      };
      await ApiService.transaction(
        data,
        (res) => {
          if (res.processed) {
            ApiService.successMsg("Transaction successfull");
            ApiService.getHeaderContents();
            ApiService.getInventory((res) => {
              let inventory = res.filter((i) => i.value.schema == "characters");
              inventory.map(async (item, i) => {
                inventory[i].value.locked = ApiService.isExpired(
                  item.value.lock_end
                );
              });
              this.$store.commit("addInventory", inventory);
            });
            this.hideModal([]);
          }
        },
        (error) => {
          ApiService.errorMsg(ApiService.errorFormat(error));
        }
      );
    },
  },
};
</script>
  
  <style scoped>
.modal-wrapper .modal-content {
  padding: 5px 0px;
  height: auto;
}
.name{
  text-transform: uppercase;
}
.energy-wrapper {
  display: flex;
  justify-content: center;
}
.energy-content img {
  width: 70px;
  aspect-ratio: 3/2;
  object-fit: contain;
  height: 100%;
  padding: 8px;
}
.energy-content p {
  color: var(--mainWhite);
  margin-bottom: 0;
}
</style>
  